
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import PageLoader from 'global/Loading/PageLoader';
import Valuation from 'features/valuation';
import MainLayout from 'global/MainLayout';
import useProtectedRoute from 'hooks/useProtectedRoute';
import SEO from 'global/SEO';
import Paywall from 'features/paywall/Wrapper/Page';

function ValuationPage() {
  const { isLoaded } = useProtectedRoute();

  return (
    <>
      <SEO title="Stockbit Valuation" />
      <MainLayout isFlexibleWidth>
        <PageLoader loaded={isLoaded} />
        <Paywall feature="VALUATION" isFlexible>
          <Valuation />
        </Paywall>
      </MainLayout>
    </>
  );
}

export default ValuationPage;
